import NinetyNinetyReport from '../pages/NinetyNinetyReport';

const ninetyninetyReporRoute = {
  public: [],
  auth: [
    {
      name: 'ninety_ninety_report',
      path: 'report/ninety-ninety-report',
      permissions: [
        'KASM',
        'KASOM',
        'KASROM',
        'KASH',
        'SAM',
        'RSM',
        'NSM-SPARTAN',
        'admin',
        'COO',
        'EXECUTIVE',
      ],
      component: NinetyNinetyReport,
    },
  ],
};

export default ninetyninetyReporRoute;
